import Vue from 'vue';
import App from './App.vue';
import '@/assets/css/tailwind.css';
import 'leaflet/dist/leaflet.css';
import 'vue-select/dist/vue-select.css';
import './filters';
import router from './router';

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
